/**
 * IDs y generadores deterministas. Nunca usan `Math.random()` ni `Date.now()`
 * para decidir un valor de dominio (solo timestamps informativos en la UI),
 * porque el motor debe producir el mismo resultado para la misma entrada
 * cuando `options.deterministic` está activo (que es siempre, en este MVP).
 */

/** Hash FNV-1a de 32 bits, determinista y sin dependencias externas. */
export function stableHash(input: string): string {
  let hash = 0x811c9dc5;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
}

/** Versión numérica de stableHash, útil como semilla de un PRNG. */
export function stableHash32(input: string): number {
  return parseInt(stableHash(input), 16) >>> 0;
}

/**
 * Generador pseudoaleatorio determinista (mulberry32). Dado el mismo `seed`
 * produce siempre la misma secuencia de valores en [0, 1) — así la estrategia
 * "randomize" del motor es reproducible entre ejecuciones idénticas, sin
 * depender de `Math.random()`.
 */
export function createSeededRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state |= 0;
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function makeRunId(scenarioId: string, payloadFingerprint: string): string {
  return `run_${scenarioId}_${payloadFingerprint}`;
}

export function fingerprintPayload(payload: unknown): string {
  return stableHash(JSON.stringify(payload));
}
